/**
 * @generated SignedSource<<58f29115090e9ac894b1cbad42cc00bc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RecurrenceFrequency = "DAILY" | "MONTHLY" | "WEEKLY" | "YEARLY";
export type TaskImportance = "OPTIONAL" | "REQUIRED";
export type RecurrenceRuleInput = {
  byhour?: ReadonlyArray<number> | null;
  byminute?: ReadonlyArray<number> | null;
  bymonth?: ReadonlyArray<number> | null;
  bymonthday?: ReadonlyArray<number> | null;
  bysecond?: ReadonlyArray<number> | null;
  byweekday?: ReadonlyArray<number> | null;
  byweekno?: ReadonlyArray<number> | null;
  byyearday?: ReadonlyArray<number> | null;
  dtstart?: string | null;
  duration?: number | null;
  freq: RecurrenceFrequency;
  interval?: number | null;
  isAllDay?: boolean | null;
  tasks: ReadonlyArray<RecurrenceRuleTaskDescriptionInput>;
  until?: string | null;
  wkst?: number | null;
};
export type RecurrenceRuleTaskDescriptionInput = {
  importance: TaskImportance;
  taskId: string;
};
export type KPIEditFrequencyMutation$variables = {
  routineId: string;
  rule: RecurrenceRuleInput;
};
export type KPIEditFrequencyMutation$data = {
  readonly routine: {
    readonly updateSchedule: {
      readonly routine: {
        readonly id: string;
        readonly schedule: {
          readonly rules: ReadonlyArray<{
            readonly byhour: ReadonlyArray<number | null> | null;
            readonly byminute: ReadonlyArray<number | null> | null;
            readonly byweekday: ReadonlyArray<number | null> | null;
            readonly freq: RecurrenceFrequency;
          }>;
        } | null;
      } | null;
    } | null;
  } | null;
};
export type KPIEditFrequencyMutation = {
  response: KPIEditFrequencyMutation$data;
  variables: KPIEditFrequencyMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "routineId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "rule"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "routineId"
      }
    ],
    "concreteType": "RoutineMutation",
    "kind": "LinkedField",
    "name": "routine",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "fields": [
              {
                "items": [
                  {
                    "kind": "Variable",
                    "name": "rules.0",
                    "variableName": "rule"
                  }
                ],
                "kind": "ListValue",
                "name": "rules"
              }
            ],
            "kind": "ObjectValue",
            "name": "input"
          }
        ],
        "concreteType": "UpdateRoutinePayload",
        "kind": "LinkedField",
        "name": "updateSchedule",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Routine",
            "kind": "LinkedField",
            "name": "routine",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Schedule",
                "kind": "LinkedField",
                "name": "schedule",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RecurrenceRule",
                    "kind": "LinkedField",
                    "name": "rules",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "freq",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "byhour",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "byminute",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "byweekday",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "KPIEditFrequencyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "KPIEditFrequencyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "910f4cc7f947fb083ffda92126315b8b",
    "id": null,
    "metadata": {},
    "name": "KPIEditFrequencyMutation",
    "operationKind": "mutation",
    "text": "mutation KPIEditFrequencyMutation(\n  $routineId: ID!\n  $rule: RecurrenceRuleInput!\n) {\n  routine(id: $routineId) {\n    updateSchedule(input: {rules: [$rule]}) {\n      routine {\n        id\n        schedule {\n          rules {\n            freq\n            byhour\n            byminute\n            byweekday\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5e87b0b0e354a8972fd60729c6e9831f";

export default node;
